import { useEffect, useContext } from 'react';
import { AppContext } from '../context/AppContext';
import axios from 'axios';

const useStripeKey = () => {
  const { appState, appDispatch } = useContext(AppContext);

  useEffect(() => {
    const VARS = appState.envVars;
    const ROOT_URL = VARS.ROOT_URL;
    const STRIPE_KEY_URL = ROOT_URL + VARS.STRIPE_KEY_API;

    const nonce = window.ttnonce || window.TTI_REST_NONCE;

    axios
      .get(STRIPE_KEY_URL + '/?_wpnonce=' + nonce)
      .then(({ data }) => {
        if (data && data.key) {
          appDispatch({
            type: 'setStripeKey',
            key: data.key,
          });
        } else {
          console.log('Error retrieving Stripe key');
        }
      })
      .catch((err) => {
        console.log('Error retrieving Stripe key: ', err.msg);
      });
  }, [appDispatch, appState.envVars]);
};

export default useStripeKey;
